<template>
	<div class="login-layout">
		<div class="login-container">
			<router-view></router-view>
		</div>
	</div>
</template>

<script setup lang="ts"></script>

<style scoped>
.login-layout {
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #f5f5f5;
}

.login-container {
	width: 100%;
	max-width: 600px;
	padding: 2rem;
	background: white;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
